import { useSyncExternalStore } from "react";

// Gates on primary-pointer capability, not viewport width: a narrow desktop pane (e.g. the Outlook
// taskpane) is still mouse-driven, and a large tablet is still touch.
const FINE_POINTER_QUERY = "(pointer: fine) and (hover: hover)";

function useMediaQuery(query: string): boolean {
  const subscribe = (onChange: () => void) => {
    const mediaQuery = window.matchMedia(query);
    mediaQuery.addEventListener("change", onChange);
    return () => mediaQuery.removeEventListener("change", onChange);
  };
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    () => false,
  );
}

/** True on fine-pointer + hover devices (mouse/trackpad), false on touch. */
export function useHasFinePointer(): boolean {
  return useMediaQuery(FINE_POINTER_QUERY);
}
